import Butsudan from '../assets/category/butsudan.jpg';
import Butsugu from '../assets/category/butsugu.jpg';
import Ihai from '../assets/category/ihai.jpg';
import Memorialgoods from '../assets/category/memorialgoods_20_capsele.jpg';
import Obon from '../assets/category/obon.jpg';
import Ordermade from '../assets/category/ordermade.jpg';
import Ordernmade from '../assets/category/ordernmade_24_cover.jpg';
import Senkoakari from '../assets/category/senkoakari.jpg';

// TODO: add description
const CATEGORIES = [
  {
    title: 'ペット仏壇',
    description:
      '可愛らしい仏壇や、インテリアに合わせやすいモダンな仏壇まで、様々なデザインのペット仏壇がそろっています。\n写真を飾ったり、他のグッズと組み合わせたり、うちの子だけの特別なメモリアルスペースにしてください。',
    imageUrl: Butsudan,
    subCategories: [
      {
        title: '手元供養BOX',
        description:
          '骨壺を入れてお手元で供養いただける箱型のケースです。骨壺だけでなく、ペットちゃんがお気に入りだったおもちゃや首輪等、遺品を入れていただく事もできます。\n名前を入れられる、世界で一つのオーダーメイドBOXもご用意しております。',
      },
      {
        title: '手元供養ステージ',
        description:
          '仏壇よりも手軽に供養したいけど、骨壺や仏具をそのまま棚に置くのはしのびない…という方におすすめのステージ型の手元供養商品です。\n骨壺、仏具、位牌等、様々な商品からペットちゃんお好みのものをお選びいただき、ステージにのせてください。',
      },
      {
        title: '手元供養ステージ・仏具セット',
        description:
          '手元供養ステージと仏具がセットになっているので、何を選んだらいいか分からない…という方にもおすすめです。\n必要なものがそろっているので、届いたらすぐご供養いただけます。同じデザインテイストで揃えられているので、ペットちゃんの雰囲気に合わせてお選びください。',
      },
      {
        title: '祭壇',
        description:
          '祭壇というと仰々しいイメージがありますが、＆COCO（アンドココ）の祭壇は可愛らしいものや、シンプルなもの、お部屋に置いても違和感のない祭壇です。\n写真を飾ったり、他のグッズと組み合わせたり、うちの子だけの特別なメモリアルスペースにしてください。',
      },
    ],
  },
  {
    title: 'ペット仏具',
    description:
      'ろうそく立て、香炉、花立て、水入れ、供物皿等、仏壇やお位牌に合わせてご利用いただけるペット仏具を集めました。\n初めての事でペット供養に何が必要なのか分からない…という方におすすめの仏具セットもご用意しております。バリエーション豊富な商品の中から、あの子に合わせて、1つずつ選んでいくのもいいですね。',
    imageUrl: Butsugu,
    subCategories: [
      {
        title: 'お供えフラワー',
        description:
          'いつでも綺麗なお花をお供えしてあげたいけど、生花だと大変…そんな方におすすめなのがお供えフラワーです。\n優しい雰囲気のちりめん素材で作られたお花や、華やかでリアルなお花等、仏壇や他の仏具に合わせてお選びください。',
      },
      {
        title: 'お花立て',
        description:
          '仏壇や位牌と共に生花や造花をお供えするためのお花立て。色とりどりのお花は、ペットちゃんだけでなくお供えする飼い主さんの気持ちも癒してくれます。\n和花にも洋花にも合うお花立てでペットちゃんの仏壇やお写真に彩りを加えていただけます。',
      },
      {
        title: 'おりん',
        description:
          'おりんを鳴らす意味は色々ありますが、ご家庭でご供養する際のおりんには、亡くなったペットちゃんへのお祈りや、ごはんをお供えする時など、ペットちゃんに挨拶する時の合図のようなイメージです。\n澄んだ音色が癒されるおりんで、ペットちゃんにたくさん話しかけてください。',
      },
      {
        title: '香炉',
        description:
          'お線香やお香を焚くときの器である香炉。パステルカラーや透明なガラス製など、ペットちゃんのために作られた香炉が多くそろっています。\n香炉の中に灰や香炉石を入れ、お線香を立てていただく以外にも、香木を入れたりするのもおすすめです。大好きだったおやつの香を天国に届けてみるのもいいかもしれませんね。',
      },
      {
        title: '仏具セット',
        description:
          '初めての事でペット供養に何が必要なのか分からない…という方におすすめの仏具セットです。\nろうそく立て、香炉、花立て、水入れ、供物皿等がセットになっているので、初めてでも安心。基本のセットをそろえた後、必要なものを足していくのがおすすめです。',
      },
      {
        title: 'ろうそく・線香立て',
        description:
          'ろうそく立てやお線香立てを集めました。かわいい肉球デザインの線香立てや、お線香とろうそくの両方に使えるものなど、様々なデザインをご用意しております。\n香りやろうそくの明りが、ペットちゃんを亡くした飼い主さんの心を癒してくれます。',
      },
      {
        title: '供物皿、水入れ',
        description:
          '食いしん坊だったあの子のために、おやつやごはんをお供えできる供物皿とお水入れ。\n美味しそうに大好きなおやつを食べていたかわいい顔を思い出しながら、お供えしてあげてください。',
      },
    ],
  },
  {
    title: 'ペット位牌',
    description:
      'あの子の写真や名前を入れてお作りするオーダーメイドのペット位牌と、お写真を挟んでいただき、愛おしい面影を偲ぶ事ができるお位牌がございます。\nあの子のかわいい姿や思い出の1枚を入れて、これからも一緒の時を過ごしてください。',
    imageUrl: Ihai,
    subCategories: [
      {
        title: 'アクリル位牌',
        description:
          'ペットちゃんのお写真や名前を入れてオリジナルのアクリル位牌をオーダーしていただけます。\nあの子のかわいい姿をアクリルにプリントして、これからも一緒の時を過ごしてください。',
      },
    ],
  },
  {
    title: '骨壺・骨袋',
    description:
      'スタンダードな骨壺から、お骨以外の毛や歯、爪など大切な小さな形見を納めていただくのにぴったりなミニ骨壺まで、様々なサイズの骨壺と骨壺カバーをご紹介しております。\n季節や記念日などに合わせて着せ替えてあげられる骨壺カバーは、いくつあってもいいですよね。',
    imageUrl: Ordernmade,
    subCategories: [
      {
        title: 'ミニ骨壺',
        description:
          'ご自宅などで大事にしまっておくには、ミニ骨壷が最適です。\n分骨といって、一部のお骨をお納めいただいたり、小さなペットちゃんのお骨を納めるものです。\nお骨以外にも毛や歯、爪など大切な小さな形見を納めていただくのにぴったりです。',
      },
      {
        title: '骨壺カバー',
        description:
          'スタンダードな骨壺カバーから、ペットちゃんにぴったりのかわいいデザインまで数多く取り揃えております。\n季節や記念日などに合わせて着せ替えてあげられる骨壺カバーは、いくつあってもいいですよね。\nペットちゃんのお写真をプリントできるオーダー骨壺カバーもおすすめです。',
      },
    ],
  },
  {
    title: '線香・ろうそく・灯',
    description:
      '小さくて可愛らしいサイズのろうそくから、火を使わないから安心のLEDキャンドルまで、様々な明りとお線香を集めました。\nお線香は、ローズやさくら、白檀の香り等、たくさんの香りを用意しております。季節や気分によって香りを変えていただくのもおすすめです。さくらの季節のお散歩道を思い出しながら、優しい香りに癒されてください。',
    imageUrl: Senkoakari,
    subCategories: [
      {
        title: '線香・お香',
        description:
          'ペットちゃん専用のお線香は、微煙タイプ。ローズやさくら、白檀の香り等、たくさんの香りを用意しております。\n季節や気分によって香りを変えていただくのもおすすめです。さくらの季節のお散歩道を思い出しながら、優しい香りに癒されてください。',
      },
      {
        title: 'ろうそく・キャンドル',
        description:
          'ペットちゃんにぴったりの小さくて可愛らしいサイズのろうそくから、火を使わないから安心のLEDキャンドルまで、様々な明りを集めました。ちりめん素材が優しい雰囲気のお花で囲まれたキャンドルは、LEDキャンドルだからできる演出です。',
      },
      {
        title: '灯籠',
        description:
          '柔らかな明りに癒される、お盆におすすめの灯籠です。\n小さなサイズながら本格的なデザインの灯籠は、暖かいオレンジ色の明りが灯ります。',
      },
    ],
  },
  {
    title: 'お盆',
    description:
      'お盆のペット供養におすすめのちょうちんやお供えです。お盆の盆棚にお供え物と一緒にお飾りする精霊馬（しょうりょううま）は、お盆にご先祖様の行き帰りの乗り物として飾ります。\n透明感のある涼やかなきゅうりやナス、小さくてかわいらしいちょうちんのお飾りで、家族をお迎えしてください。',
    imageUrl: Obon,
    subCategories: [
      {
        title: 'お盆用品',
        description:
          'お盆の盆棚にお供え物と一緒にお飾りする精霊馬（しょうりょううま）です。\nお盆にご先祖様の行き帰りの乗り物として飾ります。\nきゅうりは足の速い馬として\nなすは歩くのが遅い牛として見立てられています。',
      },
      {
        title: 'ちょうちん・お供え',
        description:
          'お盆のペット供養におすすめのちょうちんやお供えをそろえました。\n透明感のある涼やかなきゅうりやナス、小さくてかわいらしいちょうちんのお飾りで、ペットちゃんをお迎えしてください。',
      },
    ],
  },
  {
    title: 'メモリアルグッズ',
    description:
      'ワンちゃんやネコちゃんのやさしい雰囲気の手作りお飾りやフォトフレーム等、家族のご供養にぴったりのメモリアルグッズがございます。\nいつでもあの子と一緒にいられる、遺骨カプセルは、ご遺骨のほかに、遺毛やひげ等の小さなものを入れていただく事もできます。チャームを付けてアレンジするのもおすすめです。',
    imageUrl: Memorialgoods,
    subCategories: [
      {
        title: '遺骨カプセル',
        description:
          'いつでもあの子と一緒にいられる、遺骨カプセル。ネックレスタイプやキーホルダータイプ等、様々なタイプのカプセルがございます。\nご遺骨のほかに、遺毛やひげ等の小さなものを入れていただく事もできます。チャームを付けてアレンジするのもおすすめです。',
      },
      {
        title: 'メモリアルグッズ',
        description:
          'ペットちゃんのメモリアルグッズをご紹介。\nワンちゃんやネコちゃんのやさしい雰囲気の手作りお飾りやフォトフレーム等、ペットのご供養にぴったりのメモリアルグッズがございます。',
      },
    ],
  },
  {
    title: 'オーダーメイドグッズ',
    description:
      '生前の姿をずっと残しておける、あの子の写真プリントや名入れができるオーダーメイドのメモリアルグッズを集めました。\n写真が入るお位牌や写真から作るクッション、骨壺カバーなど、様々なデザインでご用意しております。',
    imageUrl: Ordermade,
    subCategories: [
      {
        title: 'オーダーメイド手元供養ステージ',
        description:
          'ペットちゃんのお写真や名前を入れて、オーダーメイドの手元供養ステージをお作りいただけます。\nアクリル素材で写真が映えるステージには、ペットちゃんのお名前、日付、メッセージを入れられます。',
      },
      {
        title: 'お写真入り位牌',
        description:
          '円形や四角、楕円形のクリスタルガラスやアクリルにお写真と名前を入れてお位牌をお作りいただけます。幸せのクローバーデザインや、キュートなパステルレインボー等、様々なデザインをご用意。＆COCO（アンドココ）の中でも人気の商品です。',
      },
      {
        title: '写真入り骨壺カバー',
        description:
          'ベーシックな骨壺カバーは、なんだか味気ない…と感じる飼い主さんも多いと思います。\nそこでおすすめなのが、ペットちゃんのお写真をプリントできるオーダーメイドの骨壺カバー。ピンク、ブルー、レインボーとカラフルなデザインが可愛いと好評です。',
      },
      {
        title: '名入れメモリアルBOX',
        description:
          '名前や日付が入れられる名入れメモリアルBOXは、ふたの部分に好きなお写真を入れていただけます。手元供養の骨壺を入れていただく他にも、お気に入りだったおもちゃや、お洋服などの遺品を納めていただくのもおすすめです。',
      },
      {
        title: 'メモリアルクッション',
        description:
          '大人気のオーダーメイドクッション！ペットちゃんのお写真を切り抜いて、その形に合わせたクッションの形になるから、まるでそこにいるかのように感じられます。\n裏地のデザインや素材が選べて、お名前を入れられるタイプもございます。体のサイズに合わせて、お選びください。',
      },
    ],
  },
];

export const mainCategories = CATEGORIES.map((category) => category.title);

export const getSubCategories = (title: string) => {
  const category = CATEGORIES.find((category) => category.title === title);
  return category ? category.subCategories.map((subCategory) => subCategory.title) : [title];
};

export const subCategories = CATEGORIES.reduce(
  (array, category) => array.concat(category.subCategories),
  [] as (typeof CATEGORIES)[number]['subCategories'],
);

export const subCategoryTitles = CATEGORIES.reduce(
  (array, category) => array.concat(category.subCategories.map((subCategory) => subCategory.title)),
  [] as string[],
);

export const getCategoryImage = (handle: string) =>
  CATEGORIES.find((category) => category.title === handle)?.imageUrl ?? '';

export const allCategories = CATEGORIES.reduce(
  (array, category) =>
    array.concat([
      category.title,
      ...category.subCategories.map((subCategory) => subCategory.title),
    ]),
  [] as string[],
);

export const getDescription = (title: string) =>
  CATEGORIES.find((category) => category.title === title)?.description ??
  subCategories.find((subCategory) => subCategory.title === title)?.description ??
  '';
